import { FC } from 'react';
import {
  NumberFormatValues,
  PatternFormat,
  SourceInfo,
} from 'react-number-format';
import cx from 'classnames';

import styles from './InputMask.module.sass';

export interface InputMaskProps {
  id: string;
  name: string;
  format: string;
  mask: string;
  value: string;
  onChange: (newValue: string) => void;
  onBlur: () => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  isError?: boolean;
  floating?: boolean;
}

const InputMask: FC<InputMaskProps> = (props) => {
  const {
    id,
    name,
    format,
    mask,
    value,
    onChange,
    onBlur,
    className = '',
    placeholder = '',
    disabled = false,
    readOnly = false,
    required = false,
    autoFocus = false,
    isError = false,
    floating = false,
  } = props;

  const changeHandler = (
    values: NumberFormatValues,
    sourceInfo: SourceInfo,
  ) => {
    onChange(values.value);
  };

  const blurHandler = () => {
    onBlur();
  };

  const showPlaceholderAsLabel = floating && !!placeholder;
  const wrapperClassName = cx(
    styles.input,
    isError && styles.error,
    floating && styles.floating,
    className,
  );

  return (
    <div className={wrapperClassName}>
      <PatternFormat
        id={id}
        name={name}
        type="text"
        className={styles.field}
        value={value as string}
        onValueChange={changeHandler}
        onBlur={blurHandler}
        format={format}
        mask={mask}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        autoFocus={autoFocus}
      />

      {showPlaceholderAsLabel && (
        <label htmlFor={name} className={styles.label}>
          {placeholder}
        </label>
      )}
    </div>
  );
};

export default InputMask;
